import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, CardContent } from '@design-system-coopeuch/web';
import { useDevice } from '../../../../hooks';
import IconPersonSuccess from '../../../assets/img/icon/icon-person-success.svg';
import IconPersonError from '../../../assets/img/icon/User-Error.svg';
import IconPersonErrorMobile from '../../../assets/img/icon/User-Error-Mobile.svg';
import btnCerrar from '../../../assets/img/icon/btn-cerrar.svg';
import { WrapperModal } from './styles';

const ModalRespuestaEncuesta = ({
  tipoRespuesta,
  setOpenModalRespuestaEncuesta,
  titulo,
  descripcion,
  botonAccion,
  botonTexto
}) => {
  const { isMobile } = useDevice();
  return (
    <WrapperModal>
      <div className="modal">
        <div className="modal-content">
          <Card>
            <CardContent className="tituloModal">
              <div className="barraTop">
                <Button variant="text" onClick={() => setOpenModalRespuestaEncuesta(false)}>
                  <img src={btnCerrar} alt="close" />
                </Button>
              </div>
            </CardContent>
            <CardContent className="cardSiguiente">
              <div className="iconSuccessContainer">
                {!isMobile ? (
                  <img
                    className="iconPersonSuccessImg"
                    src={tipoRespuesta === 'exito' ? IconPersonSuccess : IconPersonError}
                    alt="icon-person"
                  />
                ) : (
                  <img
                    className="iconPersonSuccessImg"
                    src={tipoRespuesta === 'exito' ? IconPersonSuccess : IconPersonErrorMobile}
                    alt="icon-person"
                  />
                )}
              </div>
              <div className="titulo">{titulo}</div>
              <div className="subtitulo">{descripcion}</div>
              <div className="volver">
                <Button className="botonTerminar" variant="outline" onClick={botonAccion}>
                  {botonTexto}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </WrapperModal>
  );
};
ModalRespuestaEncuesta.propTypes = {
  tipoRespuesta: PropTypes.string.isRequired,
  setOpenModalRespuestaEncuesta: PropTypes.func.isRequired,
  titulo: PropTypes.string.isRequired,
  descripcion: PropTypes.string.isRequired,
  botonAccion: PropTypes.func.isRequired,
  botonTexto: PropTypes.string.isRequired
};

export default ModalRespuestaEncuesta;
